<!-- DIY模板 -->
<template>
    <div class="container">
        <div class="toolbar">
            <Input
                class="w200"
                type="text"
                v-model="storePrams.name"
                clearable
                placeholder="请输入模板名称"
            ></Input>
            <Button
                class="theme-bc theme-default-color"
                icon="ios-search"
                @click="goSearch"
            >确认搜索</Button>
            <Button
                class="theme-bc theme-default-color"
                icon="md-add-circle"
                @click="goModal(1)"
            >新增模板</Button>
        </div>
        <div class="card-grid">
            <div v-for="row in dataTable" :key="row.id" class="template-card">
                <div class="card-header">
                    <div class="card-title-wrap">
                        <Input
                            v-if="editingId === row.id"
                            v-model="editingTitle"
                            class="title-input"
                            :ref="'titleInput_' + row.id"
                            @on-enter="saveTitle(row)"
                        ></Input>
                        <span v-else class="card-title cursor-pointer" @click="startEdit(row)">{{ row.title }}</span>
                    </div>
                    <div class="card-actions">
                        <template v-if="editingId === row.id">
                            <Button type="text" size="small" @click="cancelEdit">取消</Button>
                            <Button type="primary" size="small" @click="saveTitle(row)">保存</Button>
                        </template>
                        <template v-else>
                            <img src="@/assets/edit_name.png" alt="" class="edit-icon cursor-pointer" @click="startEdit(row)" />
                        </template>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card-info-item">
                        <span class="info-label">创建时间：</span>
                        <span class="info-value">{{ row.created_at }}</span>
                    </div>
                </div>
                <div class="card-footer">
                    <Button type="primary" ghost @click="goManage(row)">管理</Button>
                    <Button class="btn-copy" @click="goCopy(row)">复制</Button>
                    <Button type="error" ghost @click="goDel(1, row)">删除</Button>
                </div>
            </div>
            <div v-if="dataTable.length === 0" class="empty-state">
                <Icon type="md-document" size="48" color="#ccc" />
                <p>暂无数据</p>
            </div>
        </div>
        <div class="pagination">
            <Page
                :current="storePrams.page"
                :total="total"
                :page-size="storePrams.limit"
                show-elevator
                show-total
                @on-change="pageChange"
            />
        </div>
        <!-- 复制模板 -->
        <Modal
            v-model="copyModal"
            title="复制模板"
            :width="400"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="模板名称">
                        <Input
                            type="text"
                            style="width:200px"
                            v-model="formItem.title"
                            placeholder="请输入模板名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelCopyModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitCopyModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 模板管理 -->
        <Modal
            v-model="manageModal"
            title="模板管理"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goModal(2)"
                    >新增页面</Button
                >
                <Table :columns="columnManage" :data="dataManage" border>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <div class="w90">
                                <Button
                                    v-if="row.is_index != 1"
                                    type="success"
                                    ghost
                                    @click="setHome(row)"
                                    >设为首页</Button
                                >
                            </div>
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(2, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="ta-r mt24">
                    <Page
                        :current="storePramsManage.page"
                        :page-size="storePramsManage.limit"
                        :total="totalManage"
                        show-elevator
                        show-total
                        @on-change="pageChangeManage"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增模板/编辑模板 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="400"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formItem"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="模板名称">
                        <Input
                            style="width:200px"
                            type="text"
                            v-model="formItem.title"
                            placeholder="请输入模板名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 新增页面 -->
        <Modal
            v-model="page_modal"
            title="新增页面"
            :width="400"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="page_data"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="页面名称：">
                        <Input
                            type="text"
                            style="width:200px"
                            v-model="page_data.title"
                            placeholder="请输入页面名称"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelPageModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitPageModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- editDiy全屏弹窗 -->
        <editDiy
            v-model="editDiyModal"
            :is-modal="true"
            :diy-id="editDiyProps.diyId"
            :page-id="editDiyProps.pageId"
            :template-id="editDiyProps.templateId"
            :page-title="editDiyProps.pageTitle"
            @on-close="closeEditDiyModal"
        ></editDiy>
    </div>
</template>

<script>
import {
    template_diy_list,
    template_diy_copy,
    template_diy_manage,
    template_diy_del,
    template_diy_save,
    template_diy_del_manage,
    template_diy_set,
} from "@/api/index";
import editDiy from "./editDiy.vue";
export default {
    components: {
        editDiy
    },
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
            },
            total: 0,
            dataTable: [],
            storePramsManage: {
                page: 1,
                limit: 10,
                id: "",
            },
            totalManage: 0,
            columnManage: [
                { type: "index", width: 60, align: "center" },
                { title: "页面名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataManage: [],
            copyModal: false,
            manageModal: false,
            modals: false,
            modalTitle: "",
            manageData: {
                id: "",
                diy_template_id: "",
            },
            formItem: {
                title: "",
                id: "",
            },
            page_modal: false,
            page_data: {
                title: "",
            },
            editingId: null,
            editingTitle: "",
            editDiyModal: false,
            editDiyProps: {
                pageId: "",
                templateId: "",
                diyId: "",
                pageTitle: ""
            },
        };
    },
    mounted() {
        this.dataTable = [];
        this.getList();
    },
    methods: {
        // 开始编辑标题
        startEdit(row) {
            this.editingId = row.id;
            this.editingTitle = row.title;
            this.$nextTick(() => {
                const inputRef = this.$refs['titleInput_' + row.id];
                if (inputRef && inputRef[0]) {
                    inputRef[0].focus();
                }
            });
        },
        // 取消编辑
        cancelEdit() {
            this.editingId = null;
            this.editingTitle = "";
        },
        // 保存标题
        saveTitle(row) {
            if (!this.editingTitle.trim()) {
                this.$Message.error("请输入模板名称");
                return;
            }
            template_diy_save({
                id: row.id,
                title: this.editingTitle.trim()
            }).then((res) => {
                row.title = this.editingTitle.trim();
                this.editingId = null;
                this.editingTitle = "";
                this.$Message.success(res.msg);
            }).catch((res) => {
                this.$Message.error(res.msg);
            });
        },
        // 关闭editDiy弹窗
        closeEditDiyModal() {
            this.editDiyModal = false;
            this.getManageList();
        },
        cancelPageModal() {
            this.page_modal = false;
        },
        submitPageModal() {
            this.manageData.id = "";
            // if (!this.page_data.title) {
            //     this.$Message.error("请填写页面名称");
            //     return;
            // }
            this.page_modal = false;
            // 打开editDiy弹窗
            this.editDiyProps = {
                pageId: this.manageData.id,
                templateId: this.manageData.diy_template_id,
                diyId: "1",
                // pageTitle: this.page_data.title
                pageTitle: ""
            };
            this.editDiyModal = true;
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getList() {
            template_diy_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Page @on-change
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeManage(index) {
            this.storePramsManage.page = index;
            this.getManageList();
        },
        // 设置默认首页
        setHome(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认设置默认首页为（" + row.title + "）吗？",
                onOk: () => {
                    template_diy_set({ id: row.id })
                        .then((res) => {
                            this.getManageList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // DIY模板管理列表
        getManageList() {
            template_diy_manage(this.storePramsManage)
                .then((res) => {
                    this.dataManage = res.data.data;
                    this.totalManage = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 删除
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        template_diy_del({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        template_diy_del_manage({ id: row.id })
                            .then((res) => {
                                this.getManageList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        goCopy(row) {
            this.formItem.title = row.title;
            this.formItem.id = row.id;
            this.copyModal = true;
        },
        goManage(row) {
            this.storePramsManage.id = row.id;
            this.manageData.diy_template_id = row.id;
            this.getManageList();
            this.manageModal = true;
        },
        goModal(index, row) {
            console.log("index:", index)
            console.log("row:", row)
            if (index == 1) {
                if (row) {
                    this.modalTitle = "编辑模板";
                    this.formItem.title = row.title;
                    this.formItem.id = row.id;
                } else {
                    this.modalTitle = "新增模板";
                    this.formItem.id = "";
                    this.formItem.title = "";
                }
                this.modals = true;
            } else if (index == 2) {
                if (row) {
                    this.manageData.id = row.id;
                    // 打开editDiy弹窗
                    this.editDiyProps = {
                        pageId: this.manageData.id,
                        templateId: this.manageData.diy_template_id,
                        diyId: "1",
                        pageTitle: row.title
                    };
                    this.editDiyModal = true;
                } else {
                    // 新增页面
                    // this.page_modal = true;
                    this.submitPageModal();
                }
            }
        },
        // 取消
        cancelCopyModal() {
            this.copyModal = false;
        },
        // 确定
        submitCopyModal() {
            template_diy_copy(this.formItem)
                .then((res) => {
                    this.getList();
                    this.copyModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 取消
        cancelModal() {
            this.modals = false;
        },
        // 确定
        submitModal() {
            template_diy_save(this.formItem)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
}
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
}
.template-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    overflow: hidden;
    transition: box-shadow 0.2s ease;
}
.template-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}
.card-title {
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
}
.edit-icon {
    width: 16px;
    height: 16px;
    opacity: 0.5;
}
.edit-icon:hover {
    opacity: 1;
}
.card-title-wrap {
    flex: 1;
    min-width: 0;
}
.title-input {
    width: 200px;
}
.title-input input {
    font-size: 15px;
    font-weight: 600;
}
.card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}
.card-body {
    padding: 16px 20px;
}
.card-info-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}
.card-info-item:last-child {
    margin-bottom: 0;
}
.info-label {
    color: #64748b;
    font-size: 14px;
}
.info-value {
    color: #0f172a;
    font-size: 14px;
}
.card-footer {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 20px;
    border-top: 1px solid #e2e8f0;
}
.btn-copy {
    color: #6c52ff;
}
.pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
}
.empty-state {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px;
    color: #94a3b8;
}
.empty-state p {
    margin-top: 12px;
}
</style>